/**
 * Page manager placement for live access
 */
export const PM_PLACEMENT_SPOTLIGHT_LIVE_ACCESS = 'live-access-spotlight'

export default { PM_PLACEMENT_SPOTLIGHT_LIVE_ACCESS }
